module.exports = __webpack_public_path__ + "img/5_2.ea5ad820.png";